import { configureStore } from "@reduxjs/toolkit";
import appReducer from "./reducer/app";
import testReducer from "./reducer/test";
import studentReducer from "./reducer/student";

export default configureStore({
  reducer: {
    app: appReducer,
    test: testReducer,
    student: studentReducer,
  },
});
